import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from 'src/_metronic/helpers';

export interface IFlashProductCancelConfirmModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

const DEFAULT_MESSAGE = 'Seçilen ürünlere ait flaş indirimleri iptal etmek istediğinize emin misiniz?';
const DEFAULT_TITLE = 'Flaş indirimlerini iptal et';
const DEFAULT_CONFIRM_LABEL = 'Evet, iptal et';

export default function FlashProductCancelConfirmModal({
  show,
  onHide,
  onConfirm,
  isLoading = false,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  confirmLabel = DEFAULT_CONFIRM_LABEL,
}: IFlashProductCancelConfirmModalProps) {
  const handleClose = () => {
    if (!isLoading) onHide();
  };

  return (
    <Modal
      className="modal fade"
      id="kt_modal_flash_cancel_confirm"
      tabIndex={-1}
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      centered
      role="dialog"
      aria-hidden="true"
    >
      <div className={`modal-content min-w-150px position-relative ${isLoading ? 'opacity-50' : ''}`}>
        <div className="modal-header pb-0">
          <div className="fw-bolder fs-4">{title}</div>
          <div className="btn btn-icon btn-sm btn-active-light-primary" onClick={handleClose} aria-label="Kapat">
            <KTSVG path="/media/icons/duotone/Navigation/Close.svg" className="svg-icon-2x" />
          </div>
        </div>

        <div className="modal-body">
          <div className="mb-4 d-flex align-items-center">
            <KTSVG path="/media/icons/duotone/General/Info.svg" className="svg-icon-2x me-4 svg-icon-danger text-danger" />
            <label className="col-form-label fs-6 text-gray-700">{message}</label>
          </div>
        </div>

        <div className="modal-footer w-100 p-0">
          <div className="d-flex justify-content-end align-items-center mb-5 px-5 w-100 mt-4">
            <button
              type="button"
              className="btn btn-light me-4 px-10"
              onClick={handleClose}
              disabled={isLoading}
            >
              Vazgeç
            </button>
            <button
              type="button"
              className="btn btn-light-danger px-10 w-150"
              onClick={onConfirm}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" />
                  İptal ediliyor...
                </>
              ) : (
                confirmLabel
              )}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
